<template>
    <b-modal :id="modalId" size="lg" hide-footer hide-header>
        <b-card v-show="actionPlan" no-body>
            <b-card-header>
                <i class="icon-note"></i>
                <strong>{{ $t('form.edit', { item: $t('pdis.actionPlan') }) }}</strong>
            </b-card-header>
            <b-card-body>
                <Loader :loader="loader" />
                <FormActionPlan
                    v-if="!loader"
                    @onSubmit="onSubmit"
                    @cancel="closeModal"
                    :actionPlan="actionPlan"
                    :actionPlanPromise="actionPlanPromise"
                    :isEditing="true"
                    :can-edit="true"
                />
            </b-card-body>
        </b-card>
    </b-modal>
</template>

<script>
import api from '@/services/api'
import i18n from '@/i18n'
import FormActionPlan from './components/FormActionPlan'
import { success, danger } from '@/lib/notification'
import Loader from '@/views/components/loader'
import { mapperActionPlanToAPI } from './mappers/mapperActionPlanToAPI'
import { getUserPermissions } from '@/services/user-permissions'

export default {
    name: 'Edit',
    components: {
        FormActionPlan,
        Loader,
    },
    props: {
        actionPlanId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            modalId: `edit-action-plan-modal${this.actionPlanId}`,
            actionPlanPromise: null,
            actionPlan: null,
            loader: true,
            permissions: {},
        }
    },
    created() {
        this.permissions = getUserPermissions()
    },
    mounted() {
        this.getActionPlan()
    },
    methods: {
        getActionPlan() {
            this.actionPlanPromise = api
                .get(`/action-plans/${this.actionPlanId}`)
                .then((resp) => {
                    const {
                        data: { data },
                    } = resp
                    this.actionPlan = data
                })
                .catch((e) => {
                    console.log(e)
                    this.notificationError()
                })
                .finally(() => {
                    this.loader = false
                })
        },
        onSubmit(form, onReset, isLoading) {
            isLoading(true)

            api.put(`/action-plans/${this.actionPlanId}`, mapperActionPlanToAPI(form))
                .then(() => {
                    this.getActionPlan()
                    this.notificationActionPlanEditedSuccessfully()
                    this.closeModal()
                    this.$emit('reloadPdis')
                })
                .catch((error) => {
                    console.log(error)
                    this.notificationError()
                })
                .finally(() => {
                    isLoading(false)
                })
        },
        notificationActionPlanEditedSuccessfully() {
            success(
                i18n.t('notification.editedSuccessfully', {
                    item: i18n.t('pdis.actionPlan'),
                })
            )
        },
        notificationError() {
            danger()
        },
        closeModal() {
            this.$bvModal.hide(this.modalId)
        },
    },
}
</script>
<style lang="scss" scoped>
::v-deep .modal-body {
    padding: 0 !important;
}
</style>
